import Box from '@mui/material/Box';
import clsx from 'clsx';
import type { SxProps, Theme } from '@mui/material/styles';
import mergeSxProps from '@erikdakoda/ui/shared/mergeSxProps';

type UviloMarkProps = {
  className?: string | string[];
  sx?: SxProps<Theme>;
};

export default function UviloMark({ sx, className }: UviloMarkProps) {
  'use memo';

  const mergedSx = mergeSxProps(sx, { fontSize: 0 });
  return (
    <Box className={clsx('uvilo-mark', className)} sx={mergedSx}>
      <svg viewBox="0 0 52.1 59.6" xmlns="http://www.w3.org/2000/svg">
        <path d="M 0 0 L 22.045 0 L 22.045 33.007 C 22.045 36.053 23.397 37.577 26.083 37.577 C 28.728 37.577 30.061 36.053 30.061 33.007 L 30.061 0 L 52.106 0 L 52.106 32.587 C 52.106 40.172 49.591 46.574 44.551 51.796 C 39.5 57.016 33.328 59.621 26.023 59.621 C 17.706 59.621 11.002 56.596 5.922 50.533 C 1.974 45.804 0 39.231 0 30.823 L 0 0 Z" />
      </svg>
    </Box>
  );
}
